export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12160.e6fedf62.jpg";